import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Logger } from '../services/utils/logger';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Constants } from '../services/utils/Constants';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    s3ExplicitUrlsWithoutToken = Constants.S3_EXPLICIT_URLS_WITHOUT_TOKEN;
    skipTokenUrls = Constants.SKIP_TOKEN_URLS;

    constructor(private logger: Logger, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const email = localStorage.getItem(`CognitoIdentityServiceProvider.${environment.clientId}.LastAuthUser`);
        const { STARTS: starts, ENDS: ends } = this.s3ExplicitUrlsWithoutToken;

        if (request.url.startsWith(starts) && request.url.endsWith(ends)) {
            return next.handle(request);
        }

        if (this.skipTokenUrls.some((path) => request.url.endsWith(path))) {
          return next.handle(request);
        }

        if (!email) {
            return next.handle(request);
        }

        const primaryKey = `CognitoIdentityServiceProvider.${environment.clientId}.${email}`;
        const secondaryKey = `CognitoIdentityServiceProvider.${environment.clientIdSecondary}.${email}.secondary`;

        const primaryToken = localStorage.getItem(`${primaryKey}.idToken`);
        const secondaryToken = localStorage.getItem(`${secondaryKey}.idToken`);
        const isHavApiRequest = !!environment.HavBaseUrl && request.url.startsWith(environment.HavBaseUrl);

        const clonedRequest = request.clone({
            setHeaders: {
                ...(primaryToken && { Authorization: `Bearer ${primaryToken}` }),
                ...(secondaryToken && !isHavApiRequest && { AuthorizationSecondary: `Bearer ${secondaryToken}` }),
            }
        });

        return next.handle(clonedRequest).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 403) {
                    this.router.navigate(['/home/login']);
                }
                return throwError(() => error);
            })
        );
    }
}

